import { useState } from 'react';
import { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type LoadingProps = {
    firstLoadingInProgress: boolean,
    setFirstLoadingInProgress: ReactSetState<boolean>
}

const [useLoadingContext, Provider] = createContext<LoadingProps>('LoadingCtx');

const useInitLoadingContext = () => {
    const [firstLoadingInProgress, setFirstLoadingInProgress] = useState<boolean>(true)
    const loadingProps : LoadingProps = {
        firstLoadingInProgress,
        setFirstLoadingInProgress
    };
    return loadingProps;
};

const LoadingContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitLoadingContext()}>
        {children}
    </Provider>;
};

export { useLoadingContext, LoadingContextProvider };